import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './config/axios'
import './quasar'
import './styles/global.css'
import Router from 'vue-router'

Vue.config.productionTip = false
Vue.use(axios)
Vue.use(Router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 解决vue項目路由出現message: "Navigating to current location (XXX) is not allowed"的問題
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
